module.exports = __webpack_public_path__ + "img/Introduction_img.2ae7f937.png";